import { call, put } from "redux-saga/effects";
import { expenseService } from "../services/expenseService";
import { expenseConstants } from "../actions/constants/expenseConstants";
import { commonConstants } from "../actions/constants/commonConstants";

function* getExpenseParams(action: any): any {
  try {
    const response = yield call(expenseService.getExpenseParams, action.payload);
    if (response.success) {
      yield put({ type: expenseConstants.getExpenseParamsSuccess, payload: response.resultObject });
    } else {
      yield put({ type: expenseConstants.getExpenseParamsFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: expenseConstants.getExpenseParamsFailure, payload: error });
  }
}

function* createExpense(action: any): any {
  try {
    const response = yield call(expenseService.createExpense, action.payload);
    if (response.success) {
      yield put({ type: expenseConstants.createExpenseSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: expenseConstants.createExpenseFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: expenseConstants.createExpenseFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error.message });
  }
}

function* deleteExpense(action: any): any {
  try {
    const response = yield call(expenseService.deleteExpense, action.payload);
    if (response.success) {
      yield put({ type: expenseConstants.deleteExpenseSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: expenseConstants.deleteExpenseFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: expenseConstants.deleteExpenseFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error.message });
  }
}

function* getExpenseView(action: any): any {
  try {
    const response = yield call(expenseService.getExpenseView, action.payload);
    if (response.success) {
      yield put({ type: expenseConstants.expenseViewSuccess, payload: response.resultObject });
    } else {
      yield put({ type: expenseConstants.expenseViewFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: expenseConstants.expenseViewFailure, payload: error });
  }
}

export const expenseSaga = {
  getExpenseParams,
  createExpense,
  deleteExpense,
  getExpenseView,
};
